import { FC, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { BindInstructionsInfoAtom } from "./PolicyQuoteBindInstructionsAtoms";
import { INSURED_ATOM_KEY } from "../../../../utilities/queryStringsHash";
import { useAtomFamily } from "../../../../hooks/useAtomFamily";
import { GlobalInsuredAtomFamily } from "../../InsuredAtoms";
import { getNewAtomValueByBindInstructions } from "./PolicyQuoteBindInstructionsUtils";

const PolicyQuoteBindInstructionsSaveAtom: FC<{ tabKey }> = ({ tabKey }) => {
  const bindInstructionsInfo = useRecoilValue(BindInstructionsInfoAtom);
  const insuredIdAtomKey = `${INSURED_ATOM_KEY} ${tabKey}`;

  const { getAtom, setAtom } = useAtomFamily(
    GlobalInsuredAtomFamily(insuredIdAtomKey)
  );

  useEffect(() => {
    const olderAtom = getAtom();
    const newAtom = getNewAtomValueByBindInstructions(
      olderAtom,
      bindInstructionsInfo
    );
    setAtom(newAtom);
  }, [bindInstructionsInfo]);

  return null;
};
export default PolicyQuoteBindInstructionsSaveAtom;
